import { Col, Row, Spin, Typography } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  convertToTitleCase,
  formatCurrency,
  formatDate,
  formatDateRange,
  getRentFreePeriodValue,
} from "../../../../libs/utils";
import { Modal } from "../../components";
import { getLeaseTerms } from "../../ducks/actions";
import { torRulesOption } from "../../utils";
import Item from "./Item";
import { useGetLeaseDuration } from "../../hooks/useGetLeaseDuration";

interface IProps {
  booking: any;
  renewal: boolean;
  contractNumber?: any;
}

const index = (props: IProps) => {
  const { Title } = Typography;
  const dispatch: any = useDispatch();
  const linkStyle = { textTransform: "uppercase", color: "#184461" };
  const isBooking = props?.booking && Object.keys(props.booking).length > 0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  let torExist = torRulesOption?.find((item) => item?.value === props.booking?.torType);
  const leaseTerms = props.booking?.parentLeaseTerms || props.booking?.leaseTerms;
  const bookingTerms = props.booking?.parentBookingTerms || props.booking?.bookingTerms;

  const rentFreeDateValue = getRentFreePeriodValue(leaseTerms);
  const rentFreePeriod = rentFreeDateValue
    ? `${rentFreeDateValue} ${parseInt(rentFreeDateValue) === 1 ? "Day" : "Days"}`
    : `0 Days`;

  const usagesType = props?.booking?.propertyDetails?.usagesType;
  const [termsCondition, setTermsConditionId] = useState(null);

  useEffect(() => {
    (async () => {
      if (props.booking.termsConditionId) {
        try {
          const response = await dispatch(
            getLeaseTerms(props.booking.propertyId, props.booking?.propertyDetails?.usagesType)
          );
          const term = response.find((term) => term._id === props.booking.termsConditionId);
          setTermsConditionId(term);
        } catch (e) {}
      }
    })();
  }, [props]);

  const bookingExpireTime = dayjs(props.booking?.bookingExpiryDate?.split("Z")[0]).format("HH:mm a");

  let modalPayload = {
    iKey: "16",
    // title: "Booking Date Extension",
    title: (
      <Title level={3} className="mb-0">
        Booking Date Extension
      </Title>
    ),
    open: isModalOpen,
    extraText: "",
    width: "50%",
  };

  //  if lease History inlude these status then hide request extension button story 9783
  let statusList = [];
  const loginUserType = JSON.parse(window.localStorage.getItem("login-response"))?.usertype;

  const checkLeaseHistory = () => {
    props?.booking?.leaseStatusHistory?.forEach((history) => {
      statusList.push(history.status);
    });
    if (
      statusList?.includes("active") ||
      statusList?.includes("contract_signed") ||
      statusList?.includes("sent_for_lease_approval") ||
      statusList?.includes("booking_cancelled")
    ) {
      return false;
    } else if (
      statusList?.includes("booking_extension_requested") &&
      props?.booking?.bookingExtension?.submittedDate &&
      props?.booking?.bookingExtension?.status === "pending"
    ) {
      return "booking_extension_requested";
    } else if (
      props?.booking?.bookingExtensionApproval === "enable" &&
      (loginUserType.includes("leaseExecutive") || loginUserType.includes("institutionalLandlord"))
    ) {
      return "ok";
    } else {
      return false;
    }
  };

  const { label } = useGetLeaseDuration(
    leaseTerms?.leaseStartDate,
    leaseTerms?.leaseEndDate
  );

  return (
    <Col span={24} className="view-booking">
      {!isBooking && (
        <Row gutter={24} className="loading">
          <Spin size="large" />
        </Row>
      )}

      {isBooking && (
        <>
          <Row gutter={24} className="bd-item">
            <Item label={`Lease Executive`} value={convertToTitleCase(props.booking?.leaseManager?.name)} />
            <Item label="External Agent" value={convertToTitleCase(props.booking?.externalAgent)} />
            <Item label="Lease Nature" value={convertToTitleCase(leaseTerms?.leaseNature)} />

            {usagesType != "Commercial" && (
              <Item label="Number of Occupants" value={props.booking?.tenantDetails?.numberOfOcupants || 1} />
            )}

            {!props.renewal &&
              props.booking?.bookingTerms?.bookingStartDate &&
              props.booking?.bookingTerms?.bookingEndDate && (
                <Item
                  label="Booking Period"
                  value={formatDateRange(
                    props.booking?.bookingTerms?.bookingStartDate,
                    props.booking?.bookingTerms?.bookingEndDate
                  )}
                />
              )}

            {!props.renewal && usagesType === "Commercial" && (
              <Item
                label="Fit-Out Period"
                value={formatDateRange(
                  leaseTerms?.fitOutStartDate,
                  leaseTerms?.fitOutEndDate
                )}
              />
            )}

            <Item value={rentFreePeriod && rentFreePeriod} label="Rent Free Period" />

            <Item
              label="Lease Term"
              value={formatDateRange(leaseTerms?.leaseStartDate, leaseTerms?.leaseEndDate)}
            />

            {usagesType === "Commercial" && <Item label={"Lease Duration"} value={label} />}
            <Item
              label={usagesType === "Commercial" ? "Move-in / Handover Date" : "Move-in Date"}
              value={formatDate(leaseTerms?.moveInDate)}
            />
            <Item label="Current Annual Rent" value={formatCurrency(bookingTerms?.annualBaseRent)} />
            <Item label="Current Contract Rent" value={formatCurrency(leaseTerms?.contractAmount)} />
            <Item label="Rent Commencement Date" value={formatDate(leaseTerms?.commencementDate)} />
            {/* <Item
              label={usagesType === "Commercial" ? "Duration" : "Number of Years"}
              value={props.booking?.leaseTerms?.numberOfYears}
            /> */}

            {props?.contractNumber && <Item label="Ejari Contract Number" value={props?.contractNumber} />}
            {props.booking?.bookingExpiryDate && (
              <Item
                showModal={setIsModalOpen}
                label="Booking Expiry"
                bookingExpiry
                requestExtenstionShow={checkLeaseHistory()}
                value={`${formatDate(props.booking?.bookingExpiryDate)} ${
                  bookingExpireTime?.startsWith("00:00") ? "" : bookingExpireTime
                }`}
              />
            )}

            <Item label="Number Of parking Slots" value={leaseTerms?.noOfFreeParkingSlots} />
            {usagesType === "Commercial" && (
              <Item label="Lease Type" value={`${convertToTitleCase(torExist?.label)}`} />
            )}

            {termsCondition && <Item label="Terms & Conditions" valueStyle={linkStyle} valueLink={termsCondition} />}
          </Row>
        </>
      )}

      <Modal
        bookingExpiryDate={props.booking?.bookingExpiryDate}
        modalPayload={modalPayload}
        requestExtension={setIsModalOpen}
      />
    </Col>
  );
};

export default React.memo(index);
